import Vue from 'vue';
import bootstrap from  './bootstrap';

// components
import App                from './Main'
import DataTableCustomers from './components/p-data-table'
import widgetClientInfo   from './components/widget-client-info'
import PCard              from './components/p-card'
import PMainLayout        from './components/p-main-layout'
import PClientForm        from './components/p-client-form'
import PRequestTest       from './components/p-request-test'
import PTollbar           from './components/p-toolbar'
import PUserRouter        from './components/profile/p-user-router'
import PrevidIa           from './components/previd-ia'
import Sidebar            from './components/sidebar'

//Pages
import Login        from './pages/login'


//plugins
import Eventbus    from './plugins/eventbus'
import VuePaginate from 'vue-paginate'
Vue.use(require('vue-moment'));
import VueTheMask from 'vue-the-mask'
import Notifications from 'vue-notification'
Vue.use(Notifications)
// SETUP
Vue.config.productionTip = process.env.NODE_ENV === 'production' ? true : false;
import store from './store/store'

Vue.use(VueTheMask)
Vue.use(Eventbus);
Vue.use(VuePaginate)

//fontawesome
import { library }          from '@fortawesome/fontawesome-svg-core'
import { faPowerOff }       from '@fortawesome/free-solid-svg-icons'
import { faKey }            from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon }  from '@fortawesome/vue-fontawesome'
library.add(faPowerOff, faKey)
Vue.component('font-awesome-icon', FontAwesomeIcon)

var app = new Vue({
   el: '#app',
   store,
   components: {
       App,
      DataTableCustomers,
      widgetClientInfo,
      PCard,
      PMainLayout,
      PClientForm,
      PRequestTest,
      PTollbar,
      PUserRouter,
      Login,
      PrevidIa,
      Sidebar
   }
});



// WEBPACK FOOTER //
// ./src/js/app.js